import styled from "@emotion/styled";
import type { HTMLAttributes } from "react";

import { FONT_WEIGHT_BOLD } from "../utilities";
import type { PlayerPalette } from "./types";

export const ThemePaletteContainer = styled.div<{ $color: string }>`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  background: ${({ $color }) => $color};
  overflow: hidden;
  cursor: pointer;
  transition: 0.15s all ease-in;
  border-radius: ${({ theme }) => theme.borderRadius}px;
  box-shadow: 0 2px 4px -2px rgba(0, 0, 0, 0.2);
`;

const Light = styled.div<{ $color: string }>`
  display: block;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 20%;
  z-index: 1;
  background: ${({ $color }) => $color};
`;

const Dark = styled.div<{ $color: string }>`
  display: block;
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  width: 20%;
  z-index: 1;
  background: ${({ $color }) => $color};
`;

const Foreground = styled.div<{ $color: string }>`
  display: block;
  position: relative;
  z-index: 2;
  text-align: center;
  font-weight: ${FONT_WEIGHT_BOLD};
  color: ${({ $color }) => $color};
  padding: 0 8px;
  margin: 5px 0;
  flex: 1 1 100%;
  font-size: ${({ theme }) => theme.fontSizeSmall};
`;

export type ThemePaletteVisualiserProps = HTMLAttributes<HTMLDivElement> & {
  title: string;
  palette: PlayerPalette;
};

export const ThemePaletteVisualiser = ({ title, palette, ...props }: ThemePaletteVisualiserProps) => (
  <ThemePaletteContainer $color={palette.main} {...props} data-test="palette-container">
    <Light $color={palette.light} data-test="light" />
    <Foreground $color={palette.foreground} data-test="foreground">
      {title}
    </Foreground>
    <Dark $color={palette.dark} data-test="dark" />
  </ThemePaletteContainer>
);
